import { render, staticRenderFns } from "./SectionRequisites.vue?vue&type=template&id=84f0ec9c&"
import script from "./SectionRequisites.vue?vue&type=script&lang=ts&"
export * from "./SectionRequisites.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports